<app-master-data-table [data]="masterCommonService.deliveryTimesList" [columns]="deliverytimeColumns"
  title="Delivery Times List" addButtonLabel="Delivery Time" (add)="openAddUpdateDeliveryTimeDialog('add')"
  (update)="openAddUpdateDeliveryTimeDialog('update', $event)" (delete)="deleteDeliveryTime($event)">
</app-master-data-table>